<template>
    <div class="reference-house-filter">
        {{ label }}: <a href="#" @click.prevent="toggleDropdown()" class="reference-house-filter-toggle">{{ currentProductName }} <span :class="['glyphicon', toggleIconClass]"></span></a>
        <ul v-if="dropdownVisible" class="reference-house-filter-dropdown">
            <li class="reference-house-filter-dropdown-item" v-for="product in products" :key="product.id">
                <a :class="itemClassObject(product.id)" href="#" @click.prevent="selectProduct(product)">
                    {{ product.productName }}<br />
                    <span class="reference-house-filter-dropdown-item-description" v-html="getProductDescription(product.id)"></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapState } from "vuex"
    import _ from "lodash"
    import referenceHouseProducts from "../helpers/referenceHouseProducts"

    export default {
        data() {
            return {
                dropdownVisible: false,
            }
        },
        computed: {
            ...mapGetters([
              "referenceHouses",
              "currentProductName",
              "procurementModel",
            ]),
            products() {
                return _.uniqBy(this.referenceHouses.map(item => item.product), "id");
            },
            ...mapState({
                label(state) {
                    return state.procurementModel === 1 ? "Leverantör" : "Produkt"
                },
                currentProduct: state => state.refHouses.currentProduct,
            }),
            toggleIconClass() {
                return this.dropdownVisible ? "glyphicon-triangle-top" : "glyphicon-triangle-bottom"
            },
        },
        methods: {
            toggleDropdown() {
                this.dropdownVisible = !this.dropdownVisible
            },
            selectProduct(product) {
                this.$store.commit("setCurrentProduct", product)
                this.$store.commit('setCurrentReferenceHouseIndex', 0)
                this.dropdownVisible = false
            },
            getProductDescription(productId) {
                const product = _.find(referenceHouseProducts, { "productId": productId })
                return product ? product.description : ""
            },
            itemClassObject(productId) {
                return {
                    'reference-house-filter-dropdown-item-link': true,
                    active: this.currentProduct ? this.currentProduct.id === productId : false,
                }
            },
        },
        mounted() {
            if (this.procurementModel === 1 && !this.currentProduct.id) {
                this.$store.commit("setCurrentProduct", _.first(this.products))
            }
        }
    }
</script>

<style lang="scss">
    @import "./assets/stylesheets/base/colors";
    @import "./assets/stylesheets/base/typography";

    $gallery: #eeeeee;
    $wild-sand: #f5f5f5;

    .reference-house-filter {
        @extend .open-sans-regular;
        position: relative;

        .reference-house-filter-toggle {
            @extend .open-sans-semibold;

            .glyphicon {
                font-size: 10px;
                color: $off-black;
            }
        }

        .reference-house-filter-dropdown {
            position: absolute;
            top: 22px;
            left: 0;
            background: $white;
            text-align: left;
            border-radius: 3px;
            z-index: 100;
            list-style: none;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
            max-width: 450px;

            .reference-house-filter-dropdown-item {
                border-bottom: 1px solid $gallery;

                &:last-child {
                    border-bottom: node;
                }

                .reference-house-filter-dropdown-item-description {
                    @extend .open-sans-regular;
                }

                .reference-house-filter-dropdown-item-link {
                    @extend .open-sans-semibold;
                    padding: 20px;
                    display: block;
                    color: $off-black;

                    &:hover {
                        text-decoration: none;
                    }

                    &.active {
                        background: $wild-sand;
                    }


                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/refHouseFilter.vue